module.exports = __webpack_public_path__ + "static/ssb-duizhen-887b1760d52123d5c75ff93dabd7e51c.png";